module.exports = __webpack_public_path__ + "img/opex.41c7cdda.svg";